import React from 'react'

import { Amplify } from 'aws-amplify'
import ReactDOM from 'react-dom/client'

import './index.css'
import App from './App'
import outputs from '../amplify_outputs.json'

Amplify.configure(outputs)
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
